module.exports = new __parcel__URL__("ewarLogo.2c138ee8.jpg").toString();